import React from 'react'

function EnvDetector({env}) {
  return (
    <div className='cc-env-detector'>{env}</div>
  )
}

export default EnvDetector